/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Avatar from "./features/avatar";

const ManageAvatar = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Avatar />
        </section>
      </Layout>
    </>
  );
};
export default ManageAvatar;
